import {Breadcrumbs, type IconName} from '@wandb/components';
import React from 'react';
import {useParams} from 'react-router';

import * as Urls from '../../util/urls';
import {fileInfoFromName} from './fileInfoFromName';
import type {FileBrowserFile} from './types';

type Params = {
  entityName: string;
  projectName: string;
  runName: string;
};

type FilePathProps = {
  currentFile?: undefined | FileBrowserFile;
  filePath: string[];
};
export function FilePath({currentFile, filePath}: FilePathProps) {
  const {entityName, projectName, runName} = useParams<Params>();

  const links = ['root'].concat(filePath).map((folderName, i) => {
    let icon: IconName = 'folder-project';
    if (i === 0) {
      icon = 'home';
    }
    if (i === filePath.length && currentFile != null) {
      const fileInfo = fileInfoFromName(currentFile.name);
      icon = fileInfo.iconName;
    }
    return {
      children: folderName,
      icon,
      href: Urls.runTabFile(
        entityName,
        projectName,
        runName,
        filePath.slice(0, i)
      ),
    };
  });
  return <Breadcrumbs links={links} />;
}
